@for (item of links(); track $index) {
  <a
    class="relative flex h-12 w-12 place-content-center place-items-center rounded-full"
    [href]="item?.link?.url ?? item?.link?.route?.path"
    [attr.target]="item?.link?.target"
    [attr.aria-label]="item?.link?.title"
    [attr.aria-description]="item.description"
    [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
    routerLinkDetector
    matRipple
  >
    @if (item.icon && item.icon.image) {
      <img
        class="h-full dark:brightness-0 dark:invert dark:saturate-100"
        [ngSrc]="item.icon.image.url | cmsMediaPrefix"
        [alt]="item.icon.alt ?? ''"
        [title]="item.icon.title ?? ''"
        fill
      />
    }
  </a>
}
